import React from 'react';

export const Motorised: Function = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 88.45 88.45"
      {...props}
    >
      <defs>
        <clipPath id="controlmotorised_clip-path">
          <circle fill="none" cx="44.2" cy="44.2" r="36.5" />
        </clipPath>
      </defs>
      <circle
        fill="#fff"
        strokeWidth="1.45px"
        stroke="#27375f"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="44.2"
        cy="44.2"
        r="43.5"
      />
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.59 0.81 -0.81 0.59 10.58 62.28)"
      >
        M
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.81 0.59 -0.59 0.81 18.51 72.32)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(27.32 78.25)rotate(21.61)"
      >
        T
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(35.19 81.26)rotate(7.2)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(46.3 82.23)rotate(-8.23)"
      >
        R
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(55.32 80.55)rotate(-19.32)"
      >
        I
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(60.37 78.72)rotate(-29.29)"
      >
        S
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(67.24 74.63)rotate(-41.58)"
      >
        E
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(73.54 68.82)rotate(-55.83)"
      >
        D
      </text>
      <g clipPath="url(#controlmotorised_clip-path)">
        <rect
          stroke="#27375f"
          strokeMiterlimit="10"
          strokeWidth="1.5px"
          fill="none"
          x="32.4"
          y="24.2"
          width="23.3"
          height="38.5"
          rx="3.3"
        />
        <path
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          d="M47.1 20.8a4 4 0 0 0-6.5 0"
        />
        <path
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          d="M50.4 18.6a8 8 0 0 0-13 0.1"
        />
        <path
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          d="M52.5,16.2a10.58,10.58,0,0,0-17.35.08"
        />
        <rect
          stroke="#27375f"
          strokeMiterlimit="10"
          strokeWidth="1.5px"
          fill="none"
          x="36.2"
          y="28.3"
          width="15.7"
          height="8.9"
          rx="1.3"
        />
        <polyline
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          points="50.2 53.6 52.4 51.5 50.2 49.3"
        />
        <polyline
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          points="37.7 49.3 35.6 51.5 37.7 53.6"
        />
        <polyline
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          points="46.1 46.3 44 44.2 41.8 46.3"
        />
        <polyline
          fill="none"
          strokeWidth="1.5px"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#27375f"
          points="41.8 56.6 44 58.8 46.1 56.6"
        />
      </g>
    </svg>
  );
};
